import api from "../../../api";
import serviceProject from "../serviceProject";
import {
  createErrorMessage,
  createSuccessMessage,
  clearance
} from "../../../service";
import NewTabForm from "../../../NewTabForm";

const DMEFile = {
  ...serviceProject,
  api: api,
  resource: "dme-files",
  preList: function(params) {
    return `projects/${params.project_id || "-"}`;
  },
  create(
    params = {},
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {}
  ) {
    let preList = this.preList(params);
    let formData = new FormData();
    formData.append("export_file", params.export_file);
    return api
      .post(`${preList ? "/" + preList : ""}/${this.resource}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(res => {
        createSuccessMessage("upload");
        onSuccess(res);
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        errorHandler(res.response.data.errors);
        onError(res);
      });
  },
  async download(params) {
    let preList = this.preList(params);
    const url = `${this.api.apiUrl}${preList ? "/" + preList : ""}/${
      this.resource
    }/${params.id}/download`;
    new NewTabForm(url, "get", await clearance()).submit();
  },
  generateDocuments(
    params,
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {}
  ) {
    let preList = this.preList(params);
    const url = `${preList ? "/" + preList : ""}/${this.resource}/${
      params.id
    }/documents`;
    return api
      .post(url, {
        document_template: params.document_template,
        destination_folder: params.destination_folder
      })
      .then(res => {
        createSuccessMessage("create-document");
        onSuccess(res.data);
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        errorHandler(res.response.data.errors);
        onError(res);
      });
  }
};
export default DMEFile;
